import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export default function ScopeBanner() {
  const { data: cfg } = useQuery({
    queryKey: ["config"],
    queryFn: async () => (await api.get("/config")).data,
  });
  if (!cfg) return null;
  const basis = cfg.price_basis === "hammer_price" ? "Hammer price" : "Incl. buyer's premium";
  const cap = `£${Number(cfg.price_cap).toLocaleString("en-GB")}`;
  return (
    <div
      data-testid="scope-banner"
      className="flex flex-wrap items-center gap-x-6 gap-y-1 px-4 lg:px-8 py-2 bg-[#0E131F] border-b border-amber-500/20 text-[12px] font-mono tracking-wide"
    >
      <span className="text-slate-500 uppercase text-[10px] tracking-widest">Active Scope</span>
      <span><span className="text-slate-500">Price cap:</span> <span className="text-amber-400 font-semibold">{cap}</span></span>
      <span><span className="text-slate-500">Basis:</span> <span className="text-slate-200">{basis}</span></span>
      <span><span className="text-slate-500">Cities:</span> <span className="text-slate-200">{cfg.included_cities?.join(" & ")}</span></span>
      <span className="hidden sm:inline"><span className="text-slate-500">Houses:</span> <span className="text-slate-200">{cfg.included_auction_houses?.join(", ")}</span></span>
    </div>
  );
}
